import {configureStore} from '@reduxjs/toolkit';
import authReducer from './slicer/auth';

export const store = configureStore({
  reducer: {auth: authReducer},
});
